import { getCouponAffectedProductNames } from '@src/domains/coupons/core/getCouponAffectedProductNames';
import type { CouponInput, ItemWithProductName } from '@src/domains/coupons/types/couponProductScope';

export const shouldShowCouponAffectedProducts = (
  coupon: CouponInput | null | undefined,
  items: ItemWithProductName[],
  sellerAppId?: string,
): boolean => getCouponAffectedProductNames(coupon, items, sellerAppId).length > 0;
